module.exports = __webpack_public_path__ + "c86ba63559466597f246c2716be37b65.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 0